// Colores y formato de especialidades, unificados para toda la app.
// El color es determinista por id de especialidad, así una misma especialidad
// se ve del mismo color en Videos, Dashboard, Estadísticas, etc.

export const ESPECIALIDAD_COLORS = [
  '#0ea5e9', '#10b981', '#8b5cf6', '#f59e0b', '#ef4444',
  '#06b6d4', '#ec4899', '#84cc16', '#f97316', '#14b8a6',
];

export const colorEspecialidad = (id?: number): string =>
  ESPECIALIDAD_COLORS[(id ?? 0) % ESPECIALIDAD_COLORS.length];

// "MEDICINA INTERNA" -> "Medicina interna" (solo la primera letra en mayúscula)
export const capitalizarEspecialidad = (s?: string): string =>
  s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '';

// Color determinista a partir del nombre de la especialidad (cuando no hay id),
// usando la misma paleta unificada.
export const colorPorNombre = (s?: string): string => {
  if (!s) return ESPECIALIDAD_COLORS[0];
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return ESPECIALIDAD_COLORS[h % ESPECIALIDAD_COLORS.length];
};

// Mezcla de colores en hex (t = 0..1 hacia `target`). Para suavizar los colores
// saturados hacia tonos pastel/beige, sin arcoíris chillón.
const hexToRgb = (h: string): [number, number, number] => {
  const s = h.replace('#', '');
  return [parseInt(s.slice(0, 2), 16), parseInt(s.slice(2, 4), 16), parseInt(s.slice(4, 6), 16)];
};
const rgbToHex = (r: number, g: number, b: number): string =>
  '#' + [r, g, b].map((v) => Math.round(v).toString(16).padStart(2, '0')).join('');
export const mix = (a: string, b: string, t: number): string => {
  const [r1, g1, b1] = hexToRgb(a);
  const [r2, g2, b2] = hexToRgb(b);
  return rgbToHex(r1 + (r2 - r1) * t, g1 + (g2 - g1) * t, b1 + (b2 - b1) * t);
};
// Pastel suave (hacia beige claro) y tono "tinta" (hacia casi-negro) para texto/iconos.
export const pastel = (hex: string): string => mix(hex, '#f4efe7', 0.8);
export const ink = (hex: string): string => mix(hex, '#2d2a26', 0.4);
